import { ROLES_PREMISSAS_VISUALIZACAO } from "./departamentosOrcamento";

// Premissas · Assinaturas e Sistemas: leitura ampla (ROLES_PREMISSAS_VISUALIZACAO); edição só
// admin (via isAdmin em components/gestaoOrcamentaria/PremissasAssinaturasView.js).
// Espelha backend/config.py ROLES_PREMISSAS_ASSINATURAS — mantenha em sincronia.
export const ROLES_PREMISSAS_ASSINATURAS = ROLES_PREMISSAS_VISUALIZACAO;
